export type ScanEvent = Event & {
  detail: {
    barcode: string;
  };
};
export type ScanEventDetail = ScanEvent['detail'];

export const SCAN_EVENT = 'barcode-scan';

export const createScanEvent = (barcode: string): ScanEvent => {
  return new CustomEvent<ScanEventDetail>(SCAN_EVENT, {
    detail: { barcode },
  }) as ScanEvent;
};

export const readScanEvent = (event: Event): ScanEvent | null => {
  if (!(event instanceof CustomEvent)) return null;
  if (event.type !== SCAN_EVENT) return null;
  return event as ScanEvent;
};
